'use strict';
const angular = require('angular');

export class AttachmentPickerComponent {
  /*@ngInject*/
  constructor() {
    this.selected = {};
  }

  $onInit() {
    this.config = this.resolve.config;
    this.attachments = this.config.attachments;
    this.title = this.config.title || 'Attachment Select';

    if (this.config.selectedIds && Array.isArray(this.config.selectedIds)) {
      this.config.selectedIds.forEach(id => {
        this.selected[id] = true;
      })
    }
  };

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  isWordMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      mime == 'application/msword';
  }


  ok() {
    let selectedData = this.attachments.filter(att => this.selected[att._id]);
    this.close({$value: selectedData});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.attachmentPicker', [])
  .component('attachmentPicker', {
    template: require('./attachment-picker.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: AttachmentPickerComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/attachment-picker/attachment-picker.component.js